import { render, staticRenderFns } from "./ChallengeDetails.vue?vue&type=template&id=6e15d34f&"
import script from "./ChallengeDetails.vue?vue&type=script&lang=ts&"
export * from "./ChallengeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports